'use strict';

import register from './core';
import '../functions/jquery-global.js';
import chosen from 'chosen-js';

var elements = [];

register('select', function (element) {
  var $element = $(element);

  elements.push({
    element: $element,
    selected: $element.prop('selectedIndex')
  });

  $element.chosen({
    disable_search: true,
    inherit_select_classes: true
  });

  var $fade = $($element.data('fade'));

  if ($fade) {
    $element.on('chosen:showing_dropdown chosen:hiding_dropdown', function () {
      $fade.toggleClass('fade-content--active');
    });
  }
});

var $document = $(document);

$document.on('chosen:ready', function (evt, params) {
  $(params.chosen.form_field_label[0]).addClass('chosen-ready');
});

$document.on('click', '[type=reset]', function (e) {
  elements.forEach(function (obj) {
    obj.element.prop('selectedIndex', obj.selected).trigger('chosen:updated');
  });
});
